import { createSelector } from 'reselect';

import { FetchGroupsSuggestListFilter } from '../api/grid/EntitiesDataProvider';
import { SelectorItems } from '../components/CampaignAndGroupSelector/Selector/Selector';
import { SurveyStatus } from '../typings/campaigns';
import { CampaignBaseInfo, CampaignType } from '../typings/domain';
import { GdShowConditionTypeInput } from '../typings/graphql-grid';
import { GridSelection } from '../typings/grid';
import { CampaignAndGroupSelectorEntityToSelectType } from '../typings/sidebar';
import { CampaignAndGroupSelectorState } from '../typings/state';
import { State } from '../typings/state';

export const selectGroupsSuggestListFilter = createSelector(
    (state: State) => state.grid.campaignAndGroupSelector,
    (state: State, nameContains: string) => nameContains,
    (state: State, nameContains: string, campaignSelected: SelectorItems) => campaignSelected,
    (
        campaignAndGroupSelector: CampaignAndGroupSelectorState,
        nameContains: string,
        campaignSelected: SelectorItems
    ): FetchGroupsSuggestListFilter => {
        const { entityToSelectType } = campaignAndGroupSelector;

        const availableEntities = [
            CampaignAndGroupSelectorEntityToSelectType.PHRASE,
            CampaignAndGroupSelectorEntityToSelectType.PHRASE_BETA
        ];

        // Отрезаем группы с "Профилем пользователя" для CPM при добавлении фраз
        if (
            entityToSelectType &&
            availableEntities.includes(entityToSelectType) &&
            campaignSelected.type === CampaignType.CPM_BANNER
        ) {
            return {
                campaignId: campaignSelected.id,
                nameContains: nameContains,
                showConditionTypeIn: [GdShowConditionTypeInput.KEYWORD]
            };
        }

        return {
            campaignId: campaignSelected.id,
            nameContains: nameContains
        };
    }
);

export const selectItemsActiveBrandLiftCampaigns = (state: State, selection: GridSelection): CampaignBaseInfo[] => {
    const {
        grid: {
            gridData: { data: items }
        }
    } = state;
    const selectionSet = new Set(selection);

    return (items as CampaignBaseInfo[]).filter(
        item =>
            item !== undefined &&
            selectionSet.has(item.id) &&
            item.brandSurveyStatus &&
            item.brandSurveyStatus.surveyStatus === SurveyStatus.ACTIVE
    );
};
